import { useSelector } from 'react-redux';
import { permissionState } from 'redux/slices/permissionSlice';
import { surveysState } from 'redux/slices/surveySlice';
import './bannerSurveys.scss';
import SurveyModal from '../survey/SurveyModal';
import { useLazyGetSurveyByIdQuery } from 'redux/services/surveyService';
import { useState, useEffect } from 'react';
import { ISurveyDetail } from 'types/interfaces';
import Button from 'components/commons/buttons/button/Button';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { useLanguage, useTranslate } from 'context/languageContext';
import { ReactComponent as Ic_info } from 'resources/icons/Ic_Info.svg';
import { ReactComponent as Ic_close } from 'resources/icons/Ic_close.svg';

export default function BannerSurveys() {
  const selectorPermission = useSelector(permissionState);
  const surveysNew = useSelector(surveysState).flagNewSurveys;
  const lastGenericSurvey = useSelector(surveysState).lastGenericSurvey;
  const [getSurveyQuestions] = useLazyGetSurveyByIdQuery();
  const [surveyDetail, setSurveyDetail] = useState<ISurveyDetail | null>(null);
  const currentLanguage = useLanguage();
  const t = useTranslate();
  const [openSurvey, setOpenSurvey] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (lastGenericSurvey) {
      getSurveyQuestions({ id: lastGenericSurvey[0].id, locale: currentLanguage }).then((result) => {
        if (result?.isSuccess) {
          setSurveyDetail(result.data);
        }
      });
    }
    if(selectorPermission.cookies && surveysNew && lastGenericSurvey && surveyDetail){
      setOpenModal(true);
    }
  }, [selectorPermission.cookies, surveysNew, lastGenericSurvey]);

  const setNullGenericSurvey = () => {
    setOpenSurvey(false);
    setSurveyDetail(null);
  };

  const handleOpenClick = () => {
    setOpenModal(false);
    setOpenSurvey(true);
  };

  const handleCloseClick = () => {
    setOpenModal(false);
  };

  return openModal ? (
    <>
      <div className='overlay-banner'>
        <div className='banner-survey'>
          <div className='content'>
            <div className={'modal-info-header-close-icon'}>
              <div className='wrapper-close-icon' onClick={() => handleCloseClick()}>
                <SvgIcon Icon={Ic_close} />
              </div>
            </div>
            <>
              <div className='body'>
                <SvgIcon ariaLabel='Informacion' Icon={Ic_info} className='icon' />
                <p>{t('lb_new_surveys_published')}</p>
              </div>
              <div className='footer'>
                <Button
                  className='btn-cancel'
                  title={t('lb_cancelar')}
                  onClick={() => handleCloseClick()}
                  style={{ width: '100%' }}
                />
                <Button
                  className='btn-accept'
                  title={t('lb_contestar')}
                  onClick={() => handleOpenClick()}
                  style={{ width: '100%' }}
                />
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      {lastGenericSurvey && surveyDetail && openSurvey ? (
        <SurveyModal
          survey={surveyDetail}
          onClose={() => setNullGenericSurvey()}
          stopId={lastGenericSurvey.stopId ?? 0}
          lineId={lastGenericSurvey.lineId ?? 0}
          faqId={lastGenericSurvey.faqId ?? 0}
          poiId={lastGenericSurvey.poiId ?? 0}
        />
      ) : (null)
      }
    </>
  );
}
